/**
 * The Route dropdown is a per-message choice, not a mode.
 *
 * It used to hold whatever the user last picked for the rest of the pane
 * session, so choosing Story once quietly routed every later message -- "add a
 * task" included -- down the same path, with nothing on screen to explain why
 * the answer looked wrong. Reading it now also clears it.
 *
 * Kept in its own module so the reset can be tested without standing up the
 * whole taskpane (same reason composerLayout.js is separate).
 */

export const AUTO_ROUTE = "auto";

/**
 * Read the selected route and hand the selector back to Auto.
 *
 * The reset happens here, at the moment the value is captured, rather than when
 * the response lands: a request that fails, is abandoned, or outlives a session
 * switch would otherwise leave the pane pinned to a manual route with no
 * indication. The message already in flight keeps the value returned here.
 *
 * @param {HTMLSelectElement|null|undefined} selectEl
 * @returns {string} the route to send with this message
 */
export function takeRouteOverride(selectEl) {
  const selected = selectEl?.value || AUTO_ROUTE;
  if (selectEl && selected !== AUTO_ROUTE) {
    selectEl.value = AUTO_ROUTE;
  }
  return selected;
}
